import React, { useState, useContext, useEffect} from 'react';
import * as S from './styles';
import { Context } from '../../services/contexts/StateContext';
// -----------------------
import { SetFunctions } from '../../componentes/Functions';
import { ApiEvento } from '../../services/FiltrosApi/eventoApi';

export function NarracaoEvento({ narracaoDigitada, setNarracaoDigitada }) {
    const { state, dispatch } = useContext(Context);
    const { evento } = state.evento;
    const { AtualizarIdEvento } = ApiEvento();

    // Estados para modal de narração
    
    const [erroModalNarracao, setErroModalNarracao] = useState('');
    // ----------------------
    
    // ###################################################

    // Função para salvar narração do evento
    const salvarNarracaoEvento = async () => {
        setErroModalNarracao('');

        // Validar se a narração foi digitada
        if (!narracaoDigitada || narracaoDigitada.trim() === '') {
            setErroModalNarracao('Por favor, descreva como o evento aconteceu.');
            return;
        }

        // Validar tamanho mínimo
        if (narracaoDigitada.trim().length < 100) {
            setErroModalNarracao('A narração deve ter pelo menos 100 caracteres.');
            return;
        } else{
            AtualizarIdEvento({narracao: narracaoDigitada.trim()});
        }

        // Fechar modal após salvar
        setNarracaoDigitada('');
        setErroModalNarracao('');
    };

    

    

    //###################################################################################
    return (
        <>
        <S.div3>
            <S.NarracaoEventoModal>
                <S.TituloHeader>
                    <span>📝 Narração do Evento</span>
                </S.TituloHeader>

                <S.NarracaoEventoInputContainer>
                    <span style={{fontSize:"16px"}}>Descreva como o evento aconteceu:</span>
                    <S.NarracaoEventoTextarea
                    autoFocus
                    value={narracaoDigitada}
                    hasError={!!erroModalNarracao}
                    placeholder="Digite aqui a descrição detalhada de como o evento ocorreu..."
                    onChange={(e) => {
                        setNarracaoDigitada(e.target.value); 
                        setErroModalNarracao('');
                    }}
                        
                    />
                    <S.NarracaoEventoCounter>
                        {`${narracaoDigitada.length <= 100 ? 100 - narracaoDigitada.length + " caracteres restantes" : ""}`}
                    </S.NarracaoEventoCounter>
                </S.NarracaoEventoInputContainer>

                {erroModalNarracao && (
                    <S.NarracaoEventoError>
                        ❌ {erroModalNarracao}
                    </S.NarracaoEventoError>
                )}

                <S.NarracaoEventoButtonContainer>
                    <S.NarracaoEventoButton
                    narracaoDigitada={narracaoDigitada.length}
                    type='button'
                    onClick={salvarNarracaoEvento}
                    >
                        ✓ SALVAR
                    </S.NarracaoEventoButton>
                </S.NarracaoEventoButtonContainer>
            </S.NarracaoEventoModal>
        </S.div3>
    </>
    );
}
